import React from 'react'
import cx from 'classnames'

import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Message from 'components/text/Message/Message'

import s from './ExceptMobile.scss'


const ConfirmModalExceptMobile = ({
  children, confirmTitle, cancelTitle, onConfirm, onCancel, withTextCancel, confirmTestId, cancelTestId,
}) => {
  const buttonsContainerClassName = cx({
    [s.buttons]: withTextCancel,
    [s.buttonsInRow]: !withTextCancel,
  })

  return (
    <div>
      {children}
      <div className={buttonsContainerClassName}>
        {
          !withTextCancel && (
            <CommonButton
              className={s.button}
              title={cancelTitle}
              emptyGray
              back
              onClick={onCancel}
              dataTestId={cancelTestId}
            />
          )
        }
        <CommonButton
          className={s.button}
          title={confirmTitle}
          brand
          confirm
          onClick={onConfirm}
          dataTestId={confirmTestId}
        />
        {
          withTextCancel && (
            <div className={s.footer}>
              <Message
                className={s.textCancel}
                name="components.modal.ConfirmModal"
                text={cancelTitle}
                onClick={onCancel}
                dataTestId={cancelTestId}
                html
              />
            </div>
          )
        }
      </div>
    </div>
  )
}


export default ConfirmModalExceptMobile
